import React, { Component } from 'react';

import moment from 'moment';

import AccountService from '../services/AccountService';
import GoalsContestsService from '../services/GoalsContestsService';
import ContestsService from '../services/ContestsService';
import GoalsService from '../services/GoalsService';

import LocalDataManager from '../managers/LocalDataManager';

import SettingsTopBar from './Settings/SettingsTopBar';
import SettingsViewCentral from './Settings/SettingsViewCentral';
import SettingsBottomBar from './Settings/SettingsBottomBar';

import ZNumpad from './Utility/ZNumpad';

const links = [
    {
        label: 'Targets',
        icon: 'gps_fixed',
        index: 0
    },
    {
        label: 'Goals',
        icon: 'goals',
        index: 1
    }, {
        label: 'Contests',
        icon: 'contests',
        index: 2
    },
    /*, {
        label: 'Test',
        icon: 'palette',
        index: 2
    }*/
];

export default class SettingsPage extends Component {

    constructor(props) {
        super(props);

        this.state = {
            accountInfo: undefined,
            clientAccount: null,
            groupMap: {},
            groupMapReverse: {},
            locationMap: {},
            locationMapReverse: {},
            locationKpiMap: {},
            locationKpiMapReverse: {},
            masterKpiMap: {},
            masterKpiMapReverse: {},
            employeeKpiMap: {},
            employeeKpiMapReverse: {},
            activeIndex: 0,
            isScrollTop: true,
            mode: 'home',
            targets: {
                employeeTargets: [],
                locationTargets: [],
                defaultEmployeeTargets: [],
                defaultLocationTargets: [],
                generalTarget: null,
                locationToDaysInWeek: {}
            },
            activeTarget: null,
            activeTargetProperty: null,
            activeTargetKpi: null,
            goals: [],
            users: [],
            calendarDates: [],
            reportKPIs: [],
            rankedContests: [],
            raffleContests: [],
            selectedGoalId: null,
            activeGoal: null,
            selectedContestId: null,
            activeContest: null
        };

        window.zzActiveObject = this;

        // Variables
        this.goalsContestsService = new GoalsContestsService();
        this.contestsService = new ContestsService();
        this.goalsService = new GoalsService();
        this.accountService = new AccountService();

        this.dbm = new LocalDataManager();

        this.settings = this.dbm.getSettingsInfo();

        this.initializerObject = {
            accountInfo: null,
            clientAccount: null,
            groupMap: null,
            groupMapReverse: null,
            locationMap: null,
            locationMapReverse: null,
            locationKpiMap: null,
            locationKpiMapReverse: null,
            employeeKpiMap: null,
            employeeKpiMapReverse: null,
            masterKpiMap: null,
            masterKpiMapReverse: null,
            reportKPIs: null,
            users: null,
            targets: null,
            goals: null,
            calendarDates: null,
            rankedContests: null,
            raffleContests: null
        }

        this.initializerRetryObject = {
            account: 0,
            group: 0,
            user: 0,
            masterKpi: 0,
            reportKpi: 0,
            calendar: 0,
            goal: 0,
            rankedContest: 0,
            raffleContest: 0,
            target: 0,
        }
        this.retryLimit = 3;

        // Methods
        this.init = this.init.bind(this);
        this.reloadPage = this.reloadPage.bind(this);

        this.loadGroupData = this.loadGroupData.bind(this);
        this.loadUserData = this.loadUserData.bind(this);
        this.loadMasterKpiData = this.loadMasterKpiData.bind(this);
        this.loadReportKpiData = this.loadReportKpiData.bind(this);
        this.loadCalendarData = this.loadCalendarData.bind(this);
        this.loadGoalData = this.loadGoalData.bind(this);
        this.loadRankedContestData = this.loadRankedContestData.bind(this);
        this.loadRaffleContestData = this.loadRaffleContestData.bind(this);
        this.loadTargetData = this.loadTargetData.bind(this);
        this.finalizeInit = this.finalizeInit.bind(this);
        this.failInit = this.failInit.bind(this);

        this.organizeCalendarDates = this.organizeCalendarDates.bind(this);

        this.handleScrollTop = this.handleScrollTop.bind(this);
        this.handleNavChange = this.handleNavChange.bind(this);
        this.handleModeChange = this.handleModeChange.bind(this);

        this.handleDeleteGoal = this.handleDeleteGoal.bind(this);
        this.handleSaveGoal = this.handleSaveGoal.bind(this);
        this.handleSelectGoal = this.handleSelectGoal.bind(this);
        this.handleAddGoalData = this.handleAddGoalData.bind(this);

        this.handleDeleteContest = this.handleDeleteContest.bind(this);
        this.handleSaveContest = this.handleSaveContest.bind(this);
        this.handleSelectContest = this.handleSelectContest.bind(this);
        this.handleSaveContestResult = this.handleSaveContestResult.bind(this);
        this.setRaffleWinner = this.setRaffleWinner.bind(this);

        this.handleGoalArchive = this.handleGoalArchive.bind(this);
        this.handleContestArchive = this.handleContestArchive.bind(this);

        this.handleSelectTarget = this.handleSelectTarget.bind(this);
        this.handleDrillTarget = this.handleDrillTarget.bind(this);
        this.selectTargetCalendarDay = this.selectTargetCalendarDay.bind(this);
        this.selectTargetCalendarDayAll = this.selectTargetCalendarDayAll.bind(this);
        this.handleConfirmTargetChange = this.handleConfirmTargetChange.bind(this);

        this.generateNumpad = this.generateNumpad.bind(this);

        window.zzResume = () => { };
        window.zzPause = () => { };

        let self = this;
        self.props.superInit(self.init, undefined, undefined, undefined);
    }

    //#region Initializing

    init() {
        let self = this;

        self.dbm.getAccountInfo().then((accountInfo) => {
            
            if(accountInfo.isDashboardOnly)
            {
                self.props.changePage('login', false);
                return;
            }
            let locationMap = accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
                let key = e.name;
                if (!r[key]) {
                    r[key] = e.locationID;
                }
                return r;
            }, {});
            let locationMapReverse = accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.reduce((r, e) => {
                let key = e.locationID;
                if (!r[key]) {
                    r[key] = e.name;
                }
                return r;
            }, {});

            self.initializerObject.accountInfo = accountInfo;
            self.initializerObject.clientAccount = accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex];
            self.initializerObject.locationMap = locationMap;
            self.initializerObject.locationMapReverse = locationMapReverse;

            self.loadGroupData();
            self.loadUserData();
            self.loadMasterKpiData();
            self.loadReportKpiData();
            self.loadCalendarData();
            self.loadGoalData();
            self.loadRankedContestData();
            self.loadRaffleContestData();
            self.loadTargetData();
        }, (err) => {

            let trynum = ++self.initializerRetryObject.account;
            if (trynum < self.retryLimit) {
                self.init();
            } else {
                self.failInit();
            }
        });
    }

    reloadPage() {
        let self = this;

        self.initializerObject = {
            accountInfo: null,
            clientAccount: null,
            groupMap: null,
            groupMapReverse: null,
            locationMap: null,
            locationMapReverse: null,
            locationKpiMap: null,
            locationKpiMapReverse: null,
            employeeKpiMap: null,
            employeeKpiMapReverse: null,
            masterKpiMap: null,
            masterKpiMapReverse: null,
            reportKPIs: null,
            users: null,
            targets: null,
            goals: null,
            calendarDates: null,
            rankedContests: null,
            raffleContests: null
        }

        this.initializerRetryObject = {
            account: 0,
            group: 0,
            user: 0,
            masterKpi: 0,
            reportKpi: 0,
            calendar: 0,
            goal: 0,
            rankedContest: 0,
            raffleContest: 0,
            target: 0,
        }

        self.init();
    }

    loadGroupData() {
        let self = this;

        self.accountService.getGroups(self.initializerObject.clientAccount.clientAccountId, (groups) => {

            let groupMap = groups.reduce((r, e) => {
                let key = e.name;
                if (!r[key]) {
                    r[key] = e.groupId;
                }
                return r;
            }, {});
            let groupMapReverse = groups.reduce((r, e) => {
                let key = e.groupId;
                if (!r[key]) {
                    r[key] = e.name;
                }
                return r;
            }, {});

            self.initializerObject.groupMap = groupMap;
            self.initializerObject.groupMapReverse = groupMapReverse;

            self.finalizeInit();
        }, (err) => {

            let trynum = ++self.initializerRetryObject.group;
            if (trynum < self.retryLimit) {
                self.loadGroupData();
            } else {
                self.failInit();
            }
        });
    }

    loadUserData() {
        let self = this;
        self.goalsContestsService.goalUsers(self.initializerObject.clientAccount.clientAccountId, (users) => {

            self.initializerObject.users = users;

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.user;
            if (trynum < self.retryLimit) {
                self.loadUserData();
            } else {
                self.failInit();
            }
        });
    }

    loadMasterKpiData() {
        let self = this;

        self.contestsService.getMasterKpis(masterKpis => {
            masterKpis = _.sortBy(masterKpis, x => x.defaultSortOrder);

            let masterKpiMapContainer = masterKpis.reduce((r, e) => {
                let mapKey = e.name;
                let mapReverseKey = e.masterKpiId;

                if (!r.masterKpiMap[mapKey]) {
                    r.masterKpiMap[mapKey] = { name: e.name, type: "INT", masterKpiId: e.masterKpiId };
                }
                if (!r.masterKpiMapReverse[mapReverseKey]) {
                    r.masterKpiMapReverse[mapReverseKey] = { name: e.name, type: "INT", masterKpiId: e.masterKpiId };
                }

                return r;
            }, { masterKpiMap: {}, masterKpiMapReverse: {} });

            self.initializerObject.masterKpiMap = masterKpiMapContainer.masterKpiMap;
            self.initializerObject.masterKpiMapReverse = masterKpiMapContainer.masterKpiMapReverse;

            self.finalizeInit();
        }, err => {
            let trynum = ++self.initializerRetryObject.masterKpi;
            if (trynum < self.retryLimit) {
                self.loadMasterKpiData();
            } else {
                self.failInit();
            }
        });
    }

    loadReportKpiData() {
        let self = this;
        self.goalsContestsService.reportKPIs(self.initializerObject.clientAccount.clientAccountId, (reportKPIs) => {

            reportKPIs = _.sortBy(reportKPIs, (obj) => { return obj.defaultSortOrder });

            let KpiMapContainer = reportKPIs.reduce((r, e) => {

                let mapKey = e.name;
                let mapReverseKey = e.reportKpiId;

                if (!r.locationKpiMap[mapKey] && e.kpiType === "BLAST") {
                    r.locationKpiMap[mapKey] = { name: e.name, type: e.type, reportKpiId: e.reportKpiId };
                }
                if (!r.locationKpiMapReverse[mapReverseKey] && e.kpiType === "BLAST") {
                    r.locationKpiMapReverse[mapReverseKey] = { name: e.name, type: e.type, reportKpiId: e.reportKpiId };
                }
                if (!r.employeeKpiMap[mapKey] && e.kpiType === "BLASTP") {
                    r.employeeKpiMap[mapKey] = { name: e.name, type: e.type, reportKpiId: e.reportKpiId };
                }
                if (!r.employeeKpiMapReverse[mapReverseKey] && e.kpiType === "BLASTP") {
                    r.employeeKpiMapReverse[mapReverseKey] = { name: e.name, type: e.type, reportKpiId: e.reportKpiId };
                }

                return r;
            }, { locationKpiMap: {}, locationKpiMapReverse: {}, employeeKpiMap: {}, employeeKpiMapReverse: {} });

            self.initializerObject.reportKPIs = reportKPIs;
            self.initializerObject.locationKpiMap = KpiMapContainer.locationKpiMap;
            self.initializerObject.locationKpiMapReverse = KpiMapContainer.locationKpiMapReverse;
            self.initializerObject.employeeKpiMap = KpiMapContainer.employeeKpiMap;
            self.initializerObject.employeeKpiMapReverse = KpiMapContainer.employeeKpiMapReverse;

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.reportKpi;
            if (trynum < self.retryLimit) {
                self.loadReportKpiData();
            } else {
                self.failInit();
            }
        });
    }

    loadCalendarData() {
        let self = this;
        self.goalsContestsService.calendarDates(self.initializerObject.clientAccount.clientAccountId, (calendarDates) => {

            self.initializerObject.calendarDates = self.organizeCalendarDates(calendarDates);

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.calendar;
            if (trynum < self.retryLimit) {
                self.loadCalendarData();
            } else {
                self.failInit();
            }
        });
    }

    loadGoalData() {
        let self = this;
        self.goalsService.getGoalsList(false, self.initializerObject.clientAccount.clientAccountId, (goals) => {

            self.initializerObject.goals = goals;

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.goal;
            if (trynum < self.retryLimit) {
                self.loadGoalData();
            } else {
                self.failInit();
            }
        });
    }

    loadRankedContestData() {
        let self = this;

        self.contestsService.getRankedContestList(false, self.initializerObject.clientAccount.clientAccountId, (rankedContests) => {

            self.initializerObject.rankedContests = rankedContests;

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.rankedContest;
            if (trynum < self.retryLimit) {
                self.loadRankedContestData();
            } else {
                self.failInit();
            }
        });
    }

    loadRaffleContestData() {
        let self = this;

        self.contestsService.getRaffleContestList(false, self.initializerObject.clientAccount.clientAccountId, (raffleContests) => {

            self.initializerObject.raffleContests = raffleContests;

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.raffleContest;
            if (trynum < self.retryLimit) {
                self.loadRaffleContestData();
            } else {
                self.failInit();
            }
        });
    }

    loadTargetData() {
        let self = this;
        self.goalsContestsService.getTargets({
            userId: self.initializerObject.accountInfo.userId,
            clientAccountId: self.initializerObject.clientAccount.clientAccountId
        }, (targets) => {

            self.initializerObject.targets = targets;

            self.finalizeInit();
        }, (err) => {
            let trynum = ++self.initializerRetryObject.target;
            if (trynum < self.retryLimit) {
                self.loadTargetData();
            } else {
                self.failInit();
            }
        });
    }

    finalizeInit() {
        let self = this;

        let failed = false;
        Object.values(self.initializerObject).forEach(val => {
            if (val === null) {
                failed = true;
            }
        });

        if (!failed) {

            self.initializerObject.mode = 'home';
            self.initializerObject.selectedGoalId = null;
            self.initializerObject.activeGoal = null;
            self.initializerObject.selectedContestId = null;
            self.initializerObject.activeContest = null;

            self.setState(self.initializerObject, () => {
                self.props.loadingOff();
            });
        }
    }

    failInit() {
        this.props.loadingOff();
        zconfirm("There was a problem loading data. Would you like to reload the page?", () => {
            window.location.reload(true);
        });
    }


    //#endregion

    organizeCalendarDates(calendarDates) {

        let sortedCalendarDates = calendarDates.reduce((r, e) => {

            let keyListStart = [e.dayStart, e.weekStart, e.monthStart, e.quarterStart, e.yearStart]
            let keyListEnd = [e.dayEnd, e.weekEnd, e.monthEnd, e.quarterEnd, e.yearEnd]
            let timeList = ['day', 'week', 'month', 'quarter', 'year']

            for (var i = 0; i < timeList.length; i++) {
                let prd = timeList[i];
                let keyStartYear = moment(keyListStart[i]).format('YYYY');
                let keyStartMonth = moment(keyListStart[i]).format('MM');
                let keyStartDay = moment(keyListStart[i]).format('DD');
                let keyEndYear = moment(keyListEnd[i]).format('YYYY');
                let keyEndMonth = moment(keyListEnd[i]).format('MM');
                let keyEndDay = moment(keyListEnd[i]).format('DD');

                if (!r[prd].start[keyStartYear]) {
                    r[prd].start[keyStartYear] = {};
                    r[prd].start[keyStartYear][keyStartMonth] = [keyStartDay];
                } else if (!r[prd].start[keyStartYear][keyStartMonth]) {
                    r[prd].start[keyStartYear][keyStartMonth] = [keyStartDay];
                } else if (!r[prd].start[keyStartYear][keyStartMonth].includes(keyStartDay)) {
                    r[prd].start[keyStartYear][keyStartMonth].push(keyStartDay);
                }

                if (!r[prd].end[keyEndYear]) {
                    r[prd].end[keyEndYear] = {};
                    r[prd].end[keyEndYear][keyEndMonth] = [keyEndDay];
                } else if (!r[prd].end[keyEndYear][keyEndMonth]) {
                    r[prd].end[keyEndYear][keyEndMonth] = [keyEndDay];
                } else if (!r[prd].end[keyEndYear][keyEndMonth].includes(keyEndDay)) {
                    r[prd].end[keyEndYear][keyEndMonth].push(keyEndDay);
                }
            }

            return r;
        }, {
            day: { start: {}, end: {} },
            week: { start: {}, end: {} },
            month: { start: {}, end: {} },
            quarter: { start: {}, end: {} },
            year: { start: {}, end: {} }
        }
        );

        return sortedCalendarDates;
    }

    //#region Nav Handlers

    handleScrollTop(isScrollTop, scrollTop) {
        if (this.state.isScrollTop != isScrollTop) {
            this.scrollTop = scrollTop;
            this.setState({ isScrollTop: isScrollTop });
        }
    }

    handleNavChange(activeIndex, mode) {

        if (activeIndex != undefined && mode != undefined) {
            this.setState({
                activeIndex: activeIndex,
                mode: mode,
                selectedGoalId: null,
                activeGoal: null,
                selectedContestId: null,
                activeContest: null,
            });

        } else if (activeIndex != undefined && mode === undefined) {
            this.setState({
                activeIndex: activeIndex,
                selectedGoalId: null,
                activeGoal: null,
                selectedContestId: null,
                activeContest: null,
            });

        } else if (activeIndex === undefined && mode != undefined) {
            this.setState({
                mode: mode,
                selectedGoalId: null,
                activeGoal: null,
                selectedContestId: null,
                activeContest: null,
            });
        }
    }

    handleModeChange(mode) {
        this.setState({ mode: mode });
    }

    //#endregion

    //#region Goal/Contest Handlers

    handleDeleteGoal(identity) {

        zconfirm("Are you sure you want to delete " + identity.name + "?", () => {
            let self = this;
            this.props.loadingOn(() => {
                self.goalsContestsService.deleteGoal([identity.goalId], () => {
                    self.reloadPage();
                }, (err) => {

                    self.props.loadingOff();
                })
            });
        });
    }

    handleDeleteContest(identity) {

        zconfirm("Are you sure you want to delete " + identity.name + "?", () => {
            let self = this;
            this.props.loadingOn(() => {

                let delFunc = identity.rankedContestId != undefined ? "deleteRankedContest" : "deleteRaffleContest";

                self.contestsService[delFunc](identity, () => {
                    self.reloadPage();
                }, () => {
                    self.props.loadingOff();
                    alert("An error occurred deleting " + identity.name + ". Please try again.");
                });
            });
        });
    }

    handleSaveGoal(goal, callback) {

        let self = this;
        this.props.loadingOn(() => {
            self.goalsContestsService.saveGoal(goal, (res) => {
                alert("Goal Saved");
                if (callback) {
                    callback();
                }
                self.reloadPage();

            }, (err) => {
                alert("An error occurred: could not save goal");

                self.props.loadingOff();
            })
        });
    }

    handleSaveContest(contest, callback) {

        let self = this;
        this.props.loadingOn(() => {
            self.goalsContestsService.saveContest(contest, (res) => {
                alert("Contest Saved");
                if (callback) {
                    callback();
                }
                self.reloadPage();

            }, (err) => {
                alert("An error occurred: could not save contest");

                self.props.loadingOff();
            })
        });
    }

    handleSaveContestResult(contestResult, callback) {

        // let self = this;
        // self.goalsContestsService.saveContestResult(contestResult, (res) => {

        //     self.goalsContestsService.contestsByContestId(contestResult.contestId, (contests) => {

        //         let tempContests = [];
        //         for (var i = 0; i < self.state.contests.length; i++) {
        //             if (contests.length > 0 && self.state.contests[i].contestId === contests[0].contestId) {
        //                 tempContests.push(contests[0]);
        //             } else {
        //                 tempContests.push(self.state.contests[i]);
        //             }
        //         }

        //         self.setState({ contests: tempContests, activeContest: contests.length > 0 ? contests[0] : self.state.activeContest }, () => {
        //             if (callback) {
        //                 callback();
        //             }
        //         });
        //     });
        // })
    }

    setRaffleWinner(winner) {
        let self = this;

        self.props.loadingOn();
        self.contestsService.setRaffleWinner(winner, this.state.activeContest.raffleContestId, (res) => {
            self.props.loadingOff();
            alert("Contest winner " + winner + " saved.");
            self.setState({ activeContest: res });
        }, (err) => {
            self.props.loadingOff();
            alert("An error occurred while saving contest winner. Please Try again.")
        })
    }

    handleSelectGoal(identity) {
        this.setState({
            selectedGoalId: identity.goalId != this.state.selectedGoalId ? identity.goalId : null,
            activeGoal: identity.goalId != this.state.selectedGoalId ? identity : null
        });
    }

    handleAddGoalData(identity) {
        let self = this;

        this.setState({
            selectedGoalId: identity.goalId,
            activeGoal: identity,
            mode: 'results'
        }, () => {
            self.props.loadingOff();
        });
    }

    handleSelectContest(identity) {
        let contestId = identity.rankedContestId != undefined ? identity.rankedContestId : identity.raffleContestId;
        this.setState({
            selectedContestId: contestId != this.state.selectedContestId ? contestId : null,
            activeContest: contestId != this.state.selectedContestId ? identity : null
        });
    }

    handleGoalArchive(identity, isArchived) {

        let self = this;
        this.props.loadingOn(() => {
            self.goalsContestsService.setGoalArchive({
                goalContestId: identity.goalId,
                isArchived: isArchived
            }, () => {
                self.reloadPage();
            }, (err) => {

                self.props.loadingOff();
            })
        });
    }

    handleContestArchive(identity, isArchived) {
        let self = this;

        let contestId = identity.raffleContestId != undefined ? identity.raffleContestId : identity.rankedContestId != undefined ? identity.rankedContestId : 0;

        if (contestId != 0) {
            this.props.loadingOn(() => {
                self.contestsService.archiveContest(contestId,
                    () => {
                        self.reloadPage();
                    }, () => {

                        self.props.loadingOff();
                    });
            });
        } else {
            alert("An error occurred while archiving the contest. Please try again.")
        }
    }

    //#endregion

    //#region Target Handlers

    handleSelectTarget(target, propertyChange) {
        if (target === null) {
            this.setState({ activeTarget: null, activeTargetProperty: null });

            return;
        }

        if (target == 'newGen') {
            target = {
                clientAccountId: this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                dailyMinMax: 0,
                locationId: null,
                percentDelta: 0,
                reportKpiId: null,
                targetId: 0,
                newFlag: false
            }
        } else if (target.isNew != undefined && target.isNew) {

            let defaultPercentDelta = this.state.targets.generalTarget.percentDelta;
            let defaultDailyMinMax = 0;

            let defaultLocationId = null;
            let defaultReportKpiId = target.reportKpiId != undefined ? target.reportKpiId : null;

            if (this.state.activeTargetKpi != null) {
                defaultPercentDelta = this.state.activeTargetKpi.percentDelta;
                defaultDailyMinMax = this.state.activeTargetKpi.dailyMinMax;
                defaultLocationId = target.locationId;
                defaultReportKpiId = this.state.activeTargetKpi.reportKpiId;
            }

            target = {
                clientAccountId: this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                dailyMinMax: defaultDailyMinMax,
                locationId: defaultLocationId,
                percentDelta: defaultPercentDelta,
                reportKpiId: defaultReportKpiId,
                targetId: 0,
                newFlag: true,
                list: target.list
            }
            target[propertyChange] = this.state.targets.generalTarget[propertyChange]
        }

        this.setState({ activeTarget: target, activeTargetProperty: propertyChange });
    }

    handleDrillTarget(activeTargetKpi, skipScroll) {
        if (activeTargetKpi != null && (activeTargetKpi.percentDelta === null || activeTargetKpi.dailyMinMax === null)) {
            activeTargetKpi.percentDelta = this.state.targets.generalTarget.percentDelta;
            activeTargetKpi.dailyMinMax = this.state.targets.generalTarget.dailyMinMax;
            activeTargetKpi.isGeneralDefault = true;
        }

        if (skipScroll === undefined || skipScroll === null || skipScroll === false) {
            if (activeTargetKpi === null) {
                let scrollTo = this.state.activeTargetKpi != null && this.state.activeTargetKpi.where != undefined ? this.state.activeTargetKpi.where : 0;
                scrollTo = scrollTo * parseFloat(getComputedStyle(document.documentElement).fontSize);
                $('.settings-sub-container.scrollable').animate({ scrollTop: scrollTo }, 400);
            } else {
                $('.settings-sub-container.scrollable').animate({ scrollTop: '0rem' }, 400);
            }
        }

        this.setState({ activeTargetKpi: activeTargetKpi });
    }

    selectTargetCalendarDay(locationId, dayNum) {
        let self = this;

        let targets = this.state.targets;
        targets.locationToDaysInWeek[locationId] = dayNum;

        self.setState({ targets: targets }, () => {
            self.goalsContestsService.saveTargets(targets, () => {
                self.goalsContestsService.getTargets({
                    userId: self.state.accountInfo.userId,
                    clientAccountId: self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId
                }, (newTargets) => {
                    self.setState({ targets: newTargets });
                }, (err) => {
                    alert("Could not refresh target list. Please try again later.");
                })
            }, (err) => {
                alert("Could not save target. Please try again later.");
            });
        });
    }

    selectTargetCalendarDayAll(dayNum) {
        let self = this;
        zconfirm("Are you sure you want to set all locations to " + dayNum + "?", () => {
            let targets = self.state.targets;
            let keys = Object.keys(targets.locationToDaysInWeek);
            keys.forEach(key => {
                targets.locationToDaysInWeek[key] = dayNum;
            });
            self.setState({ targets: targets }, () => {
                self.goalsContestsService.saveTargets(targets, () => {
                    self.goalsContestsService.getTargets({
                        userId: self.state.accountInfo.userId,
                        clientAccountId: self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId
                    }, (newTargets) => {
                        self.setState({ targets: newTargets });
                    }, (err) => {
                        alert("Could not refresh target list. Please try again later.");
                    })
                }, (err) => {
                    alert("Could not save target. Please try again later.");
                });
            });
        });
    }

    handleConfirmTargetChange(numpadOutput) {
        let self = this;

        let newNum = parseFloat(numpadOutput);

        let target = this.state.activeTarget;
        target[this.state.activeTargetProperty] = newNum;

        let targets = this.state.targets;

        if (target.reportKpiId === null && targets.generalTarget === null) {
            targets.generalTarget = target;
        } else if ((this.state.activeTargetKpi === null && target.percentDelta === targets.generalTarget.percentDelta && target.dailyMinMax === 0) ||
            (this.state.activeTargetKpi != null && target.percentDelta === this.state.activeTargetKpi.percentDelta && target.dailyMinMax === this.state.activeTargetKpi.dailyMinMax)) {
            target.deleteFlag = true;
        }

        if (target.newFlag) {
            targets[target.list].push(target);
        }

        let activeTargetKpi = this.state.activeTargetKpi;
        if (activeTargetKpi != null && activeTargetKpi.isGeneralDefault) {
            activeTargetKpi.percentDelta = targets.generalTarget.percentDelta;
            activeTargetKpi.dailyMinMax = targets.generalTarget.dailyMinMax;
        }

        self.setState({ targets: targets, activeTarget: null, activeTargetProperty: null }, () => {
            self.goalsContestsService.saveTargets(targets, () => {
                self.goalsContestsService.getTargets({
                    userId: self.state.accountInfo.userId,
                    clientAccountId: self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId
                }, (newTargets) => {
                    self.setState({ targets: newTargets, activeTargetKpi: activeTargetKpi });
                }, (err) => {
                    alert("Could not refresh target list. Please try again later.");
                })
            }, (err) => {
                alert("Could not save target. Please try again later.");
            });
        });
    }

    generateNumpad() {


        return (links[this.state.activeIndex].label === 'Targets' ? (
            <ZNumpad
                isActive={this.state.activeTarget != null}
                handleCancel={this.handleSelectTarget.bind(null, null).bind(null, null)}
                handleConfirm={this.handleConfirmTargetChange}
                defaultValue={(this.state.activeTarget != null && this.state.activeTargetProperty != null &&
                    this.state.activeTarget[this.state.activeTargetProperty] != undefined) ? this.state.activeTarget[this.state.activeTargetProperty] : '0'}
            />) : null);
    }

    //#endregion

    render() {

        return this.state.accountInfo === undefined ? null : (
            <div id="page-outer" className="settings-page-outer">
                <SettingsTopBar
                    mode={this.state.mode}
                    links={links}
                    activeIndex={this.state.activeIndex}
                    handleNavChange={this.handleNavChange}
                    handleModeChange={this.handleModeChange}
                    toggleNav={this.props.toggleNav}
                    isScrollTop={this.state.isScrollTop}
                />

                <SettingsViewCentral
                    loadingOn={this.props.loadingOff}
                    loadingOff={this.props.loadingOn}
                    reloadPage={this.reloadPage}
                    accountInfo={this.state.accountInfo}
                    groupMap={this.state.groupMap}
                    groupMapReverse={this.state.groupMapReverse}
                    locationMap={this.state.locationMap}
                    locationMapReverse={this.state.locationMapReverse}
                    locationKpiMap={this.state.locationKpiMap}
                    locationKpiMapReverse={this.state.locationKpiMapReverse}
                    employeeKpiMap={this.state.employeeKpiMap}
                    employeeKpiMapReverse={this.state.employeeKpiMapReverse}
                    masterKpiMap={this.state.masterKpiMap}
                    masterKpiMapReverse={this.state.masterKpiMapReverse}
                    users={this.state.users}
                    reportKPIs={this.state.reportKPIs}
                    calendarDates={this.state.calendarDates}
                    handleScrollTop={this.handleScrollTop}
                    mode={this.state.mode}
                    activeIndex={this.state.activeIndex}
                    handleNavChange={this.handleNavChange}
                    handleModeChange={this.handleModeChange}
                    links={links}
                    targets={this.state.targets}
                    goals={this.state.goals}
                    rankedContests={this.state.rankedContests}
                    raffleContests={this.state.raffleContests}
                    activeTargetKpi={this.state.activeTargetKpi}
                    handleSelectGoal={this.handleSelectGoal}
                    handleAddGoalData={this.handleAddGoalData}
                    selectedGoalId={this.state.selectedGoalId}
                    activeGoal={this.state.activeGoal}
                    handleDeleteGoal={this.handleDeleteGoal}
                    handleSaveGoal={this.handleSaveGoal}
                    handleGoalArchive={this.handleGoalArchive}
                    handleSelectContest={this.handleSelectContest}
                    selectedContestId={this.state.selectedContestId}
                    activeContest={this.state.activeContest}
                    handleDeleteContest={this.handleDeleteContest}
                    handleSaveContest={this.handleSaveContest}
                    handleContestArchive={this.handleContestArchive}
                    saveContestResult={this.handleSaveContestResult}
                    setRaffleWinner={this.setRaffleWinner}
                    handleSelectTarget={this.handleSelectTarget}
                    handleDrillTarget={this.handleDrillTarget}
                    selectTargetCalendarDay={this.selectTargetCalendarDay}
                    selectTargetCalendarDayAll={this.selectTargetCalendarDayAll}
                />

                <SettingsBottomBar
                    mode={this.state.mode}
                    activeIndex={this.state.activeIndex}
                    handleNavChange={this.handleNavChange}
                    links={links}
                />

                {this.generateNumpad()}
            </div>
        );
    }
}